import { HOUSEKEEPING_TASK_STATUS_LABELS } from '@wodi/domain';
import type { HousekeepingTaskView } from '@wodi/shared';
import { Tag, type TagState } from '@wodi/ui';

import styles from '../operations/operations.module.css';

// Housekeeping words (docs/plans/phase3-kitchen-and-housekeeping.md §2.4): states are words on
// tags; overdue is a word too, never the danger colour.

const STATUS_TAG: Record<HousekeepingTaskView['status'], TagState> = {
  pending: 'pending',
  in_progress: 'active',
  done: 'done',
  skipped: 'neutral',
  overridden: 'neutral',
};

/** "Bed W1, Medical ward" or the area's name. */
export function taskPlace(task: HousekeepingTaskView): string {
  if (task.bed !== null) return `Bed ${task.bed.label}, ${task.ward?.name ?? ''}`;
  return task.area?.name ?? '';
}

export function TaskStatus({ task }: { task: HousekeepingTaskView }) {
  return (
    <span className={styles.tags}>
      <Tag state={STATUS_TAG[task.status]}>{HOUSEKEEPING_TASK_STATUS_LABELS[task.status]}</Tag>
      {task.overdue ? <Tag state="attention">Overdue</Tag> : null}
    </span>
  );
}
